import * as z from "zod/v4";

const RedoListingVariantSchema_ = z.object({
  id: z.string(),
  productId: z.string(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  msrp: z.number().nullable(),
  price: z.number().nullable(),
  currency: z.string().nullable(),
  vendor: z.string().nullable(),
  sku: z.string().nullable(),
  upc: z.string().nullable(),
  barcodes: z.array(z.string()),
});
export const RedoListingVariantSchema: z.ZodType<RedoListingVariant> =
  RedoListingVariantSchema_;
export interface RedoListingVariant
  extends z.infer<typeof RedoListingVariantSchema_> {}

export const RedoListingSchema_ = z.object({
  channel: z.literal("REDO"),
  id: z.string(),
  catalogId: z.string().nullable(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  vendor: z.string().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  variants: z.array(RedoListingVariantSchema),
});
export const RedoListingSchema: z.ZodType<RedoListing> = RedoListingSchema_;
export interface RedoListing extends z.infer<typeof RedoListingSchema_> {}
